/** @jsx jsx */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { withPrefix } from "gatsby";
import { jsx, css } from "@emotion/react";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";

import { Layout } from "../components/common";
import { MetaData } from "../components/common/meta";
import createPostFeeds from "../components/Posts";
import createPostFeedsCount from "../components/PostsCount";
import ReviewSection from "../components/common/ReviewSection.js";
import SocialReviewSection from "../components/common/SocialReviewSection";

/**
 * Single page (/:slug)
 *
 * This file renders a single page and loads all the content.
 *
 */
class Page extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPosts: 4,
            showButton: true,
            filter: "All",
            industry: "",
            country: "",
        };

        this.handleClick = this.handleClick.bind(this);
        this.setIndustry = this.setIndustry.bind(this);
        this.setCountry = this.setCountry.bind(this);
        this.setFilter = this.setFilter.bind(this);

        this.dropdown = React.createRef();
        this.dropdown1 = React.createRef();
        this.dropdown2 = React.createRef();
    }

    handleClick() {
        this.setState({
            showPosts: this.state.showPosts + 4,
            showButton: true,
        });
    }

    setFilter(filter) {
        this.setState({ filter, industry: "", country: "" });

        if (this.dropdown1.current) {
            this.dropdown1.current.style.display = "none";
        }
    }

    setIndustry(industry) {
        if (industry === this.state.industry) {
            this.setState({ industry, country: "" });
        } else {
            this.setState({ industry });
        }

        if (this.dropdown.current) {
            this.dropdown.current.style.display = "none";
        }
    }

    setCountry(country) {
        this.setState({ country });

        if (this.dropdown2.current) {
            this.dropdown2.current.style.display = "none";
        }
    }

    getTagName(tag) {
        if (tag === "KidsWear") {
            return "Kids Wear";
        }

        if (tag === "HomeandGift") {
            return "Home and Gift";
        }

        if (tag === "HealthandBeauty") {
            return "Health and Beauty";
        }
        return tag;
    }

    getProductName(product) {
        if (product === "noissueTissue") {
            return "noissue Tissue";
        }
        if (product === "noissueSticker") {
            return "noissue Stickers";
        }
        if (product === "noissueTape") {
            return "noissue Tape";
        }
        if (product === "noissueMailers") {
            return "noissue Mailers";
        }
        if (product === "noissueStamps") {
            return "noissue Stamps";
        }
        if (product === "noissueCards") {
            return "noissue Cards";
        }
        return product;
    }

    getProductTag() {
        let product = [
            "#noissueTissue",
            "#noissueSticker",
            "#noissueTape",
            "#noissueMailers",
            "#noissueStamps",
            "#noissueCards",
        ];
        return product;
    }

    getCountryTag() {
        let country = [
            "Atlanta",
            "#AUSTRALIA",
            "Bangkok",
            "Brisbane",
            "Bristol",
            "#CANADA",
            "Dubai",
            "England",
            "#FINLAND",
            "#GERMANY",
            "#HONG KONG",
            "#ITALY",
            "#KOREA",
            "Los Angeles",
            "New York",
            "#NEW ZEALAND",
            "Seattle",
            "#SINGAPORE",
            "#SPAIN",
            "#THAILAND",
            "#UNITED ARAB EMIRATES",
            "#UNITED KINGDOM",
            "#UNITED STATES OF AMERICA",
            "USA",
            "California",
            "San Francisco",
            "New Jersey",
            "Melbourne",
            "#NORWAY",
            "Manchester",
            "#SWITZERLAND",
            "London",
            "#FRANCE",
            "Wales",
            "Sydney",
            "Brooklyn",
            "#PORTUGAL",
            "Vienna",
            "Austria",
            "Manila",
            "#PHILIPPINES",
            "BIPOC",
            "Portland",
            "Oregon",
            "Gerogia",
            "#JAPAN",
            "Asia",
            "Europe",
            "Vancouver",
            "North Carolina",
            "#Pottery",
            "Utah",
            "Pacific Islander",
            "#Malaysia",
            "Chicago",
            "Macrame",
            "Puerto Rico",
            "#Ireland",
            "Denmark",
            "#Netherlands",
            "#COLOMBIA",
            "Barcelona",
            "Iowa",
            "Auckland",
            "Argentina",
            "Dominican Republic",
            "Ohio",
            "Gold Coast",
            "New South Wales",
            "Poland",
            "Israel",
            "British Columbia",
            "Toronto",
            "miami",
            "Queensland",
            "Dublin",
            "Alberta",
            "Ontario",
            "Malta",
            "Victoria",
            "#CHILE",
            "Washington DC",
            "Cyprus",
            "Vermont",
            "northwales",
            "#Poshmark",
            "Florida",
            "Paris",
            "Wanaka",
            "San Diego",
            "Bogotá",
            "Wellington",
            "Oklahoma",
            "#INDONESIA",
            "Tokyo",
            "Berlin",
            "Bali",
            "#EGYPT",
        ];

        return country;
    }

    filterControl = (filterItem, filterName, page, id) => (
        <a
            href={withPrefix(`/${page.slug}?filter=${filterItem}`)}
            onClick={(e) => {
                e.preventDefault();
                this.setFilter(filterItem);
            }}
            key={id}
            className={`${this.state.filter === filterItem ? "active" : ""}`}
        >
            {filterName}
        </a>
    );

    filters = (filtersList, page) =>
        filtersList.map((filter, id) =>
            filter === "noissue Stickers"
                ? this.filterControl("noissueSticker", filter, page, id)
                : filter === "Branding & Creative"
                ? this.filterControl("branding", filter, page, id)
                : this.filterControl(filter.replace(" ", ""), filter, page, id)
        );

    render() {
        const { data, location } = this.props;
        const { showPosts, filter, industry, country } = this.state;

        const page = data.ghostPage;
        const posts = data.allGhostPost.edges;
        const productsDataContentful = data.contentfulProducts.totalCount === 1 ? data.contentfulProducts.edges[0].node.products : [];

        let tags = [];

        posts.forEach((post) => {
            const postTags = post.node.tags;

            if (postTags && postTags.length > 0) {
                const isPost = Object.keys(postTags).some(
                    (k) => postTags[k].slug === "hash-post"
                );

                if (isPost) {
                    postTags.forEach((tag) => {
                        if (tag.slug !== "hash-post") {
                            tags.push(tag.name);
                        }
                    });
                }
            }
        });

        tags = [...new Set(tags)];

        let finalNumberOfSection = 4;
        let finalSearchRelatedThing = false;
        let isEnable = createPostFeedsCount(
            posts,
            finalNumberOfSection,
            showPosts,
            finalSearchRelatedThing,
            filter,
            industry,
            country,
            "social-review"
        );

        return (
            <>
                <MetaData data={data} location={location} type="website" />
                <Layout bodyClass={`page ${page.slug} elbrus-headless`}>
                    <div css={css`
                        margin-top: -3rem;
                        margin-bottom: -3rem;
                        @media(max-width: 768px){
                            margin-top: -6rem;
                            margin-bottom: -8rem;
                        }
                    `}>
                        <article className="content">
                            <section
                                className="content-body load-external-scripts"
                                dangerouslySetInnerHTML={{ __html: page.html }}
                            />
                            <ReviewSection />
                            <SocialReviewSection posts={posts} productsData={productsDataContentful} />
                        </article>
                    </div>
                </Layout>
            </>
        );
    }
}

Page.propTypes = {
    data: PropTypes.shape({
        ghostPage: PropTypes.shape({
            codeinjection_styles: PropTypes.object,
            title: PropTypes.string.isRequired,
            html: PropTypes.string,
            feature_image: PropTypes.string,
        }).isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
};

export default Page;

export const postQuery = graphql`
    query {
        ghostPage(slug: { eq: "reviews" }) {
            ...GhostPageFields
        }
        allGhostPost(
            sort: { order: DESC, fields: [published_at] }
            limit: 2000
            skip: 0
        ) {
            edges {
                node {
                    ...GhostPostFields
                }
            }
        }
        contentfulProducts: allContentfulCategoryPage(
            filter: {pageTitleCardTitle: {eq: "Shop All"}, products: {elemMatch: {visibleInMenu: {eq: true}, node_locale: {eq: "en-US"}}}}
        ) {
            edges {
                node {
                    id
                    products {
                        displayName
                        wildSectionTagSlug
                    }
                    node_locale
                }
            }
            totalCount
        }
    }
`;
